export const FundItemListDonation = ({
  donationWeight,
}: {
  donationWeight: number;
}) => {
  return (
    <div className="tw:flex tw:flex-col tw:h-full tw:w-[75px] tw:md:w-[100px] tw:justify-start tw:items-center tw:text-[0.75rem] tw:md:text-[1rem] tw:font-semibold">
      <div>{donationWeight}% of</div>
      <div>Fund</div>
    </div>
  );
};
